import axios from './axios';

export const servicesAPI = {
  getAll: async (params) => {
    const response = await axios.get('/services', { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await axios.get(`/services/${id}`);
    return response.data;
  },

  create: async (data) => {
    const response = await axios.post('/services', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await axios.put(`/services/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await axios.delete(`/services/${id}`);
    return response.data;
  }
};